import React from 'react'
import Results from '../QuizResults/Results'
import { useQuiz } from '../QuizProvider'
import useTranslation from '../../shared/TranslationProvider'
import { useIsDesktop } from '../../../hooks/useMediaQuery'
import Avatar from '../Avatar'

const WhatKindOfLeaderResults = () => {
  const { t } = useTranslation('what_kind_of_leader')
  const { trackContent, resultsPageAvatar } = useQuiz()

  const trackContentValues = Object.values(trackContent)

  const authoritarianScore = trackContentValues.filter(
    (item) => item.type === 'authoritarian',
  ).length
  const participatoryScore = trackContentValues.filter(
    (item) => item.type === 'participatory',
  ).length
  const handsOffScore = trackContentValues.filter(
    (item) => item.type === 'hands-off',
  ).length

  const leadershipStyles = [
    { name: 'authoritarian', score: authoritarianScore },
    { name: 'participatory', score: participatoryScore },
    { name: 'hands-off', score: handsOffScore },
  ].filter((ele) => ele['score'] > 0)

  const sortedLeadershipStyles = leadershipStyles.sort(
    (a, b) => b['score'] - a['score'],
  )

  const leadershipStyle = sortedLeadershipStyles[0].name
  const pros = t(`results.types.${leadershipStyle}.pros`)
  const cons = t(`results.types.${leadershipStyle}.cons`)

  const isDesktop = useIsDesktop()

  return (
    <Results>
      <div className="mb-8 flex pb-6 sm:justify-around">
        <div className="mt-1 flex flex-col gap-4 sm:w-9/12">
          <div className="flex flex-col gap-2">
            <h1>{t('results.great_job')}</h1>
            <h2>{t(`results.types.${leadershipStyle}.type`)}</h2>
            <p>{t(`results.types.${leadershipStyle}.description`)}</p>
            <h3>{t('results.pros')}</h3>
            {pros.map((pro, idx) => (
              <p key={`pro-p-${idx}`}>{pro}</p>
            ))}
            <h3>{t('results.cons')}</h3>
            {cons.map((con, idx) => (
              <p key={`con-p-${idx}`}>{con}</p>
            ))}
            <p>{t('results.conclusion')}</p>
          </div>
        </div>
        {isDesktop && <Avatar src={resultsPageAvatar} />}
      </div>
    </Results>
  )
}

export default WhatKindOfLeaderResults
